import { createStore, applyMiddleware, Store, Middleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import { IAppState } from './types';
import reducers from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();
const middleware: Middleware[] = [sagaMiddleware];
middleware.push(logger);

let store: Store<IAppState> = createStore(reducers, applyMiddleware(...middleware)) as Store<IAppState>;
sagaMiddleware.run(rootSaga);

export default store;






